import type { JSX } from 'react';
import { useReveal } from '@hooks/useReveal';
import { useContent } from '@data';
import './Rupture.css';

export default function Rupture(): JSX.Element {
  const ref = useReveal();
  const { RUPTURE } = useContent();

  return (
    <section className="Rupture" aria-labelledby="rupture-title">
      <div className="Rupture__inner reveal" ref={ref}>
        <div className="Rupture__content">
          <p className="Rupture__label">{RUPTURE.label}</p>
          <h2 className="Rupture__title" id="rupture-title">
            {RUPTURE.titleLead}<br />
            {RUPTURE.titleStrong}<em>{RUPTURE.titleEmphasis}</em>.
          </h2>
          {RUPTURE.paragraphs.map((text) => (
            <p className="Rupture__body" key={text.slice(0, 24)}>{text}</p>
          ))}

          <div className="Rupture__chips">
            <span className="Rupture__chip Rupture__chip--before">{RUPTURE.chipBefore}</span>
            <span className="Rupture__chip Rupture__chip--arrow">+</span>
            <span className="Rupture__chip Rupture__chip--after">{RUPTURE.chipAfter}</span>
            <span className="Rupture__chip Rupture__chip--arrow">=</span>
            <span className="Rupture__chip Rupture__chip--result">{RUPTURE.chipResult}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
